import { TravelerFeedback } from '../../components/host/TravelerFeedback';

export function PastTrips() {
  return (
    <div className="min-h-dvh bg-app-bg text-app-fg">
      <div className="px-6 md:px-10 py-8 md:py-12">
        <h1 className="text-2xl md:text-3xl font-semibold text-app-fg mb-1">Past Trips</h1>
        <p className="text-app-muted text-sm mb-8">Completed trips and their history.</p>
        <TravelerFeedback />
        <div className="flex flex-col items-center justify-center py-16 gap-4">
          <div className="w-14 h-14 rounded-2xl bg-gold/12 flex items-center justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="w-7 h-7 text-gold">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm.75-13a.75.75 0 00-1.5 0v5c0 .414.336.75.75.75h4a.75.75 0 000-1.5h-3.25V5z" clipRule="evenodd" />
            </svg>
          </div>
          <p className="text-sm text-app-muted">No past trips yet.</p>
        </div>
      </div>
    </div>
  );
}

export default PastTrips;
